import React, { useState } from 'react';
import { Box, Button, Flex, Text } from 'rebass';
import { RegionSelectNotForm } from '../RegionSelect';
import { Mutation, Query } from 'react-apollo';
import Select from 'react-select';
import gql from 'graphql-tag';
import SpinLoader from '../SpinLoader';
import styled, { keyframes } from 'styled-components';
import PayersDropDown from './PayersDropDown';
import { customDropdownBridgeStyles } from './commons';
import { InputWithLabel } from '../TextInput';
import { useEffect } from 'react';
const heartbeat = keyframes`
  0% {
    transform: scale(1)
  }
  10% {
    transform: scale(1.3)
  }
  30% {
    transform: scale(1)
  }
  40% {
    transform: scale(1)
  }
  50% {
    transform: scale(1.3)
  }
  60% {
    transform: scale(1)
  }
  to {
    transform: scale(1)
  }
`;
export const AnimateHit = styled.div`
  animation: 1.5s linear ${heartbeat};
  animation-delay: 0.5s;
`;

const GET_BRIDGE_PAYERS = gql`
  query getBridgePayersList {
    getBridgePayersList {
      id
      code
      name
    }
  }
`;

export const RUN_BRIDGE_SOFT_ELIGIBILITY = gql`
  mutation runBridgeSoftEligibility($state: String!, $payerId: String!) {
    runBridgeSoftEligibility(state: $state, payerId: $payerId) {
      id
      status
      validatedAt
      serviceTypeId
      location {
        state
      }
      payerId
      providers {
        id
        name
        type
        providerEligibilityEnabled
        serviceEligibilityEnabled
        externalId
      }
    }
  }
`;
export const SoftEligibilityForm = () => {
  const [step, setStep] = useState('info');

  return (
    <Flex flexDirection={'column'} style={{ justifyContent: 'center', alignItems: 'center' }}>
      <Flex style={{ width: '420px', padding: '24px', minHeight: '320px' }} flexDirection={'column'}>
        <Text style={{ fontSize: '24px', fontWeight: 500, textAlign: 'center' }} mb={4}>
          Coverage Confirmation
        </Text>

        <Mutation
          mutation={RUN_BRIDGE_SOFT_ELIGIBILITY}
          onCompleted={(e) => {
            if (e.runBridgeSoftEligibility) {
              setStep(e.runBridgeSoftEligibility.status);
            }
            // console.log(e);
          }}
        >
          {(runEligibility, { loading, error, data }) => {
            if (step === 'info') {
              return (
                <SoftEligibilityInfo
                  runEligibility={(payerId, state) => {
                    // console.log('runEligibility', { payerId, state });
                    runEligibility({
                      variables: {
                        state,
                        payerId,
                      },
                    });
                  }}
                />
              );
            } else if (step === 'ELIGIBLE') {
              return <Eligible />;
            } else if (step === 'INELIGIBLE') {
              return <Ineligible state={data && data.runBridgeSoftEligibility && data.runBridgeSoftEligibility.location ? data.runBridgeSoftEligibility.location.state : ''} />;
            }
          }}
        </Mutation>
      </Flex>
    </Flex>
  );
};

const Ineligible = ({ state }) => {
  return (
    <Flex flexDirection={'column'}>
      {/* <AnimateHit
        style={{ alignSelf: 'center' }}
        className="animable"
        // style={{
        //   transformOrigin: '60px 60px',
        // }}
      >
        <svg width="120" height="120" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.92 55.9999H52.08C56.1867 55.9999 58.7467 51.5466 56.6933 47.9999L36.6133 13.3066C34.56 9.75994 29.44 9.75994 27.3867 13.3066L7.30666 47.9999C5.25333 51.5466 7.81333 55.9999 11.92 55.9999ZM32 37.3333C30.5333 37.3333 29.3333 36.1333 29.3333 34.6666V29.3333C29.3333 27.8666 30.5333 26.6666 32 26.6666C33.4667 26.6666 34.6667 27.8666 34.6667 29.3333V34.6666C34.6667 36.1333 33.4667 37.3333 32 37.3333ZM34.6667 47.9999H29.3333V42.6666H34.6667V47.9999Z"
            fill="rgb(255, 148, 17)"
          />
        </svg>
      </AnimateHit> */}
      <Text mt={3} textAlign={'center'} fontWeight={500}>
        Out of Network? No Problem.
      </Text>
      <Text mt={3} textAlign={'center'} fontWeight={300}>
        {/* Paloma Health does not have Providers that accept your insurance in {state ? state : 'your state'}. */}
        It looks like we’re not in network with your plan but don’t worry, you can still receive care with us.
      </Text>
      <Text mt={2} textAlign={'center'} fontWeight={300}>
        We offer affordable self-pay options to keep care accessible. As a Paloma member, each visit is just $60, often close to what you'd pay as a specialist copay.
      </Text>
    </Flex>
  );
};

const Eligible = ({ onLoaded }) => {
  useEffect(() => {
    if (!!onLoaded) {
      onLoaded();
    }
  }, []);

  return (
    <Flex flexDirection={'column'}>
      <AnimateHit style={{ alignSelf: 'center' }}>
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M60 7.5C73.9239 7.5 87.2774 13.0312 97.1231 22.8769C106.969 32.7226 112.5 46.0761 112.5 60C112.5 73.9239 106.969 87.2774 97.1231 97.1231C87.2774 106.969 73.9239 112.5 60 112.5C46.0761 112.5 32.7226 106.969 22.8769 97.1231C13.0312 87.2774 7.5 73.9239 7.5 60C7.5 46.0761 13.0312 32.7226 22.8769 22.8769C32.7226 13.0312 46.0761 7.5 60 7.5ZM53.46 70.3575L41.7975 58.6875C41.3794 58.2694 40.8831 57.9378 40.3368 57.7115C39.7905 57.4852 39.205 57.3687 38.6137 57.3687C38.0225 57.3687 37.437 57.4852 36.8907 57.7115C36.3444 57.9378 35.8481 58.2694 35.43 58.6875C34.5856 59.5319 34.1112 60.6771 34.1112 61.8713C34.1112 63.0654 34.5856 64.2106 35.43 65.055L50.28 79.905C50.6969 80.3252 51.1929 80.6587 51.7393 80.8864C52.2857 81.114 52.8718 81.2312 53.4637 81.2312C54.0557 81.2312 54.6418 81.114 55.1882 80.8864C55.7346 80.6587 56.2306 80.3252 56.6475 79.905L87.3975 49.1475C87.8212 48.7311 88.1582 48.235 88.3892 47.6877C88.6202 47.1405 88.7405 46.5529 88.7433 45.9588C88.7461 45.3648 88.6312 44.7761 88.4053 44.2267C88.1794 43.6773 87.847 43.1781 87.4272 42.7578C87.0074 42.3375 86.5086 42.0045 85.9594 41.778C85.4103 41.5515 84.8218 41.4359 84.2277 41.4379C83.6337 41.44 83.046 41.5597 82.4984 41.79C81.9509 42.0203 81.4544 42.3568 81.0375 42.78L53.46 70.3575Z"
            fill="#04CF2C"
          />
        </svg>
      </AnimateHit>
      <Text mt={3} textAlign={'center'} fontWeight={300}>
        Good news!
      </Text>
      <Text mt={3} textAlign={'center'} fontWeight={300}>
        Paloma Health is able to accept your insurance!
      </Text>
    </Flex>
  );
};
export const BridgeEligible = Eligible;
export const BridgeIneligible = Ineligible;
export const SoftEligibilityInfo = ({ runEligibility, defaultState }) => {
  const [selectedState, setSelectedState] = useState(defaultState);
  const [selectedPayer, setSelectedPayer] = useState();
  const [memberId, setMemberId] = useState();

  return (
    <Flex flex={1} flexDirection={'column'}>
      <Flex flexDirection={'column'} style={{ gap: '16px' }}>
        <Text fontSize={'13px'} fontWeight={300} mb={3}>
          Enter your details below to help us determine your insurance coverage
        </Text>
        <RegionSelectNotForm
          styles={customDropdownBridgeStyles}
          value={selectedState}
          onSelectionChange={(val) => {
            setSelectedState(val);
          }}
          placeholder={'State'}
        />
        <PayersDropDown
          selectedPayer={selectedPayer}
          onPayerChange={(pyr) => {
            setSelectedPayer(pyr);
            setMemberId(null);
          }}
        />
        {!!selectedPayer &&
          selectedPayer.memberId && (
            <Flex flexDirection={'column'}>
              <InputWithLabel
                placeholder={`Member ID`}
                value={memberId}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  setMemberId(e.target.value.toString());
                }}
              />
              {!!selectedPayer.hint && <Text style={{ fontSize: '13px', fontWeight: 300 }}>{selectedPayer.hint}</Text>}
            </Flex>
          )}
        <Flex flex={1} />
        <Button
          mt={4}
          disabled={!selectedState || !selectedPayer || !(selectedPayer || {}).id || (!!selectedPayer.memberId && !memberId)}
          onClick={() => runEligibility(selectedPayer.bridgeId, selectedState)}
          variant={'primary'}
        >
          Confirm
        </Button>
      </Flex>
    </Flex>
  );
};
